"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResource = createResource;
exports.deleteResourceById = deleteResourceById;
exports.fetchList = fetchList;
exports.getResourceById = getResourceById;
exports.getResourceByTraining = getResourceByTraining;
exports.syncResource = syncResource;
exports.updateResourceById = updateResourceById;
exports.uploadToS3 = uploadToS3;
var _request = _interopRequireDefault(require("@/utils/request"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
// import { fileURLToPath } from 'url'

function fetchList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };

  // LHVO-3597 Pass source=adminPortal when calling Get Resource API, so that it filters records by tenant
  query.source = Constants.SOURCE_ADMIN_PORTAL;
  return (0, _request.default)({
    url: '/resources',
    method: 'get',
    params: query,
    headers
  });
}
function createResource(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/resources',
    method: 'post',
    headers,
    data
  });
}
function updateResourceById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/resources/' + id,
    method: 'patch',
    headers,
    data
  });
}
function uploadToS3(file, url) {
  const headers = {
    'Content-Type': ' '
  };
  return (0, _request.default)({
    url,
    method: 'put',
    headers,
    data: file,
    timeout: 60000
  });
}
function syncResource(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/resources/' + id + '/sync',
    method: 'post',
    headers
  });
}
function deleteResourceById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/resources/' + id,
    method: 'delete',
    headers
  });
}
function getResourceById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/resources/' + id,
    method: 'get',
    headers
  });
}
function getResourceByTraining(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/trainings/' + id + '/resources',
    method: 'get',
    headers
  });
}